import { Marker } from 'react-map-gl';
import { MarkerConfig } from '../types/MarkerConfig';
import settings from './../settings.json';
import { v4 as uuidv4 } from 'uuid';

const MapDialsBuilder: React.FC<{
  markersLocationConfigArray: MarkerConfig[];
}> = ({ markersLocationConfigArray: markerConfigsArray }) => {
  return (
    <>
      {markerConfigsArray.map((location) => (
        <Marker
          key={uuidv4()}
          latitude={parseFloat(location.geoPoint.latitude)}
          longitude={parseFloat(location.geoPoint.longitude)}
        >
          <img
            src={`${settings.Assets.DialsURL}${parseInt(
              location.score ? location.score : ''
            )}.svg`}
            width='60'
            height='60'
          />
        </Marker>
      ))}
    </>
  );
};

export default MapDialsBuilder;
